import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import GameUtils from '../utils/gameUtils';
import { useTranslation } from 'react-i18next';

export default function InviteModal(props) {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [insultMother, setInsultMother] = useState(false);
    const [generatedLink, setGeneratedLink] = useState('');

    const handleGetCode = async () => {
        try {
            const res = await GameUtils.createInviteGame();
            const gameId = res.data.id;
            setGeneratedLink(`https://sumochess.org/games/${gameId}/invitation`);
        } catch(e) {
            alert("Error generating code");
        }
    }

    const handleInvite = async () => {
        try {
            const res = await GameUtils.createInviteGame();
            const gameId = res.data.id;
            const subject = encodeURIComponent("Hi Dickhead");
            let bodyText = `Come play sumochess with me at https://sumochess.org/games/${gameId}/invitation`;
            if (insultMother) {
                 bodyText += "\nYour mums so fat when she fell in love she broke it";
            }
            const body = encodeURIComponent(bodyText);
            window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
            props.onHide();
        } catch (e) {
            alert("Error creating invite game: " + e.message);
        }
    };

    return (
        <Modal
            contentClassName="bg-dark text-white"
            show={props.show}
            onHide={props.onHide}
            centered>
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title style={{ letterSpacing: 1, fontWeight: 300, fontSize: '1.2rem' }}>
                    {t('invite_title')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-4 mt-2">
                    <Form.Control 
                        type="email" 
                        placeholder={t('enter_email')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Check 
                        type="checkbox" 
                        id="insult-mother-checkbox"
                        label={t('insult_mother_email')}
                        checked={insultMother}
                        onChange={(e) => setInsultMother(e.target.checked)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: 'none', flexDirection: 'column', alignItems: 'stretch' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: 10 }}>
                    <Button variant="danger" onClick={handleInvite}>
                        {t('send_invitation')}
                    </Button>
                </div>
                {generatedLink ? (
                    <div style={{ width: '100%', padding: 15, backgroundColor: '#333', borderRadius: 8, marginTop: 10 }}>
                        <div style={{color: '#aaa', fontSize: '0.9rem', marginBottom: 5}}>{t('share_link')}</div>
                        <div style={{ display: 'flex' }}>
                           <Form.Control type="text" readOnly value={generatedLink} className="bg-dark text-white border-secondary" style={{ marginRight: 10 }} />
                           <Button variant="warning" onClick={() => navigator.clipboard.writeText(generatedLink)}>{t('copy')}</Button>
                        </div>
                    </div>
                ) : (
                    <div style={{ width: '100%', textAlign: 'center', marginTop: 10 }}>
                       <div style={{ color: '#aaa', marginBottom: 10 }}>{t('or')}</div>
                       <Button variant="outline-light" size="sm" onClick={handleGetCode}>{t('get_link')}</Button>
                    </div>
                )}
            </Modal.Footer>
        </Modal>
    );
}
